import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const StatusContractor = () => {
  return (
    <SettingsMetaData propertyName={"Status_Contractor"} viewPropertyName={"Status"} />
  );
};
export default StatusContractor;